import { FieldType } from '../../types/Field.type';
export const CurrencyRef = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.currency.label',
    fallbackLabel: 'Currency',
    type: FieldType.Enum,
    options: [
        { key: 'AUD', label: 'fields.enm.currency.options.AUD', fallbackLabel: 'AUD' },
        { key: 'CAD', label: 'fields.enm.currency.options.CAD', fallbackLabel: 'CAD' },
        { key: 'CHF', label: 'fields.enm.currency.options.CHF', fallbackLabel: 'CHF' },
        { key: 'DKK', label: 'fields.enm.currency.options.DKK', fallbackLabel: 'DKK' },
        { key: 'EUR', label: 'fields.enm.currency.options.EUR', fallbackLabel: 'EUR' },
        { key: 'GBP', label: 'fields.enm.currency.options.GBP', fallbackLabel: 'GBP' },
        { key: 'NOK', label: 'fields.enm.currency.options.NOK', fallbackLabel: 'NOK' },
        { key: 'PLN', label: 'fields.enm.currency.options.PLN', fallbackLabel: 'PLN' },
        { key: 'SEK', label: 'fields.enm.currency.options.SEK', fallbackLabel: 'SEK' },
        { key: 'USD', label: 'fields.enm.currency.options.USD', fallbackLabel: 'USD' },
        { key: 'NZD', label: 'fields.enm.currency.options.NZD', fallbackLabel: 'NZD' },
        { key: 'MXN', label: 'fields.enm.currency.options.MXN', fallbackLabel: 'MXN' },
        { key: 'CZK', label: 'fields.enm.currency.options.CZK', fallbackLabel: 'CZK' },
    ],
    trackFieldValueWithAnalytics: false,
};
